import React, { useState, useEffect, useRef } from "react";
import { InView } from 'react-intersection-observer';
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import { motion, useViewportScroll, useTransform } from 'framer-motion';

export default function MainBanner(props) {
  const { title, header, content, mediaType, mediaSource, mediaClass, classes } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();
  const [elementTop, setElementTop] = useState(0);
  const [elementBottom, setElementBottom] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const yOffset = 100;

  useEffect(() => {
    if (!ref.current) return;

    const setValues = () => {
      setElementTop(ref.current.offsetTop);
      setElementBottom(ref.current.offsetTop + ref.current.offsetHeight);
      setClientHeight(window.innerHeight);
    };
    setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  }, [ref]);

  const opacity = useTransform(scrollY, [elementBottom, elementTop], [0, 1], "anticipate");

  const handleChange = (inView) => {
    inView ? props.setShowVerticleNav(false) : props.setShowVerticleNav(true);
    setIsVisible(inView);
  };
  return (
    <InView onChange={handleChange}>
      <div ref={ref} className={`page-main-banner-section section-gap d-flex align-v-center page-main-banner-container-width ${classes}`}>
        <div className="container">
          <div className="row d-flex flex-wrap">
            <div className="col page-main-banner-detail d-flex align-v-center">
              <div className="page-main-banner-detail-inner">
                <div><h1 className="h1" >
                  {header}</h1></div>
                <div><p >{content}</p></div>
                <div className="get_started_button" /*onClick={() => scrollTo('#form-section')}*/><a href="/contact/" className='button button-white right-arrow  black-arrow'>Get started</a></div>
              </div>
            </div>
            {mediaSource && <div className={`col page-main-banner-image d-flex ${mediaClass}`}>
              {
                mediaType === "video" &&
                <motion.div style={{ opacity }}>
                  <video autoPlay muted preload="auto" playsInline>
                    <source src={mediaSource} type="video/mp4" />
                  </video>
                </motion.div>
              }
              {
                mediaType === "image" &&
                <motion.div style={{ opacity }}>
                  <img src={mediaSource} alt="digital transformation" />
                </motion.div>
              }
            </div>}
          </div>
        </div>
      </div>
    </InView>
  );
}
